import { useEffect, useState } from "react";
import { Receipt } from "lucide-react";
import { toast } from "sonner";
import { EmptyState, PageHeader } from "./Common";
import { ConfirmButton } from "./ConfirmButton";
import { ProofDialog } from "./ProofDialog";
import { api, dateLabel, formatApiError, formatIDR } from "../lib/api";

export function PaymentList({ isAdmin, driverId }) {
  const [payments, setPayments] = useState([]);
  const [proofId, setProofId] = useState(null);

  const load = () => api.get("/payments", { params: driverId && driverId !== "all" ? { driver_id: driverId } : {} }).then((r) => setPayments(r.data));
  useEffect(() => { load(); }, [driverId]); // eslint-disable-line react-hooks/exhaustive-deps

  const cancel = async (p) => {
    try { await api.delete(`/payments/${p.id}`); toast.success("Pembayaran dibatalkan, trip kembali Belum Dibayar"); load(); }
    catch (e) { toast.error(formatApiError(e)); }
  };

  if (!payments.length) return <EmptyState title="Belum ada pembayaran" text="Riwayat pembayaran dari admin akan muncul di sini." testId="empty-payments" />;

  return (
    <div className="space-y-3" data-testid="payment-list">
      {payments.map((p, i) => (
        <div key={p.id} className="rise rounded-2xl border border-slate-200 bg-white p-4 sm:p-5 flex flex-col sm:flex-row sm:items-center gap-4" style={{ animationDelay: `${i * 40}ms` }} data-testid={`payment-row-${p.id}`}>
          <div className="h-11 w-11 rounded-xl bg-emerald-50 text-emerald-700 grid place-items-center shrink-0"><Receipt className="h-5 w-5" /></div>
          <div className="flex-1 min-w-0">
            <p className="font-heading font-semibold text-slate-900">{isAdmin ? p.driver_name : `Pembayaran ${p.month}`}</p>
            <p className="text-xs text-slate-500">{dateLabel(p.created_at)} · Bulan {p.month} · {p.trip_ids.length} trip · oleh {p.paid_by}{p.note && ` · ${p.note}`}</p>
          </div>
          <p className="font-num font-bold text-lg text-emerald-700" data-testid={`payment-amount-${p.id}`}>{formatIDR(p.amount)}</p>
          <div className="flex gap-2">
            <button onClick={() => setProofId(p.id)} className="h-10 px-4 rounded-lg bg-slate-900 text-white text-sm font-semibold hover:bg-slate-800" data-testid={`payment-proof-btn-${p.id}`}>Lihat Bukti</button>
            {isAdmin && (
              <ConfirmButton title="Batalkan pembayaran?" description="Trip terkait akan kembali berstatus Belum Dibayar." onConfirm={() => cancel(p)} testId={`cancel-payment-${p.id}`} confirmLabel="Batalkan">
                <button className="h-10 px-4 rounded-lg text-sm font-semibold text-red-600 hover:bg-red-50" data-testid={`cancel-payment-${p.id}`}>Batalkan</button>
              </ConfirmButton>
            )}
          </div>
        </div>
      ))}
      <ProofDialog paymentId={proofId} onClose={() => setProofId(null)} />
    </div>
  );
}

export function PaymentsPage({ isAdmin, children, driverId }) {
  return (
    <div>
      <PageHeader eyebrow="Riwayat" title="Pembayaran">{children}</PageHeader>
      <PaymentList isAdmin={isAdmin} driverId={driverId} />
    </div>
  );
}
